<template>
  <div
    class="profile-switcher"
    role="tablist"
    :aria-label="ariaLabel"
  >
    <a
      v-for="profile in profiles"
      :key="profile.id"
      :href="profile.href"
      class="profile-switcher__tab"
      :class="{ 'profile-switcher__tab--active': profile.id === activeProfile }"
      role="tab"
      :aria-selected="profile.id === activeProfile"
      :aria-current="profile.id === activeProfile ? 'page' : undefined"
      :tabindex="profile.id === activeProfile ? 0 : -1"
    >
      <img
        class="profile-switcher__avatar"
        :src="profile.image"
        :alt="profile.shortLabel"
        width="32"
        height="32"
        loading="lazy"
      />
      <span class="profile-switcher__name profile-switcher__name--long">
        {{ profile.label }}
      </span>
      <span class="profile-switcher__name profile-switcher__name--short">
        {{ profile.shortLabel }}
      </span>
    </a>
  </div>
</template>

<script>
import andreasImage from "../assets/3K6A7596_1_k01.jpg";
import rashaImage from "../assets/rasha-corti.png";

const profiles = [
  {
    id: "andreas",
    href: "/",
    label: "KR. Dr. Andreas J. Ludwig",
    shortLabel: "KR. Dr. Andreas J. Ludwig",
    image: andreasImage,
  },
  {
    id: "rasha",
    href: "/rasha-corti",
    label: "Rasha Corti, MSc",
    shortLabel: "Rasha Corti, MSc",
    image: rashaImage,
  },
];

export default {
  name: "ProfileSwitcher",
  props: {
    activeProfile: {
      type: String,
      required: true,
      validator: (value) => ["andreas", "rasha"].includes(value),
    },
  },
  data() {
    return {
      profiles,
    };
  },
  computed: {
    ariaLabel() {
      return this.$i18n.locale === "de" ? "Berater wechseln" : "Switch advisor";
    },
  },
};
</script>

<style scoped>
.profile-switcher {
  background: #f4f7fa;
  border: 1px solid rgba(32, 50, 79, 0.12);
  border-radius: 999px;
  display: flex;
  gap: 4px;
  padding: 4px;
  width: 100%;
}

.profile-switcher__tab {
  align-items: center;
  border-radius: 999px;
  color: #13a1c7;
  display: flex;
  flex: 1;
  font-family: "Poppins", sans-serif;
  font-size: 0.76rem;
  font-weight: 600;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0.02em;
  line-height: 1.2;
  min-height: 46px;
  min-width: 0;
  padding: 6px 12px;
  text-align: center;
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    color 0.2s ease,
    transform 0.15s ease;
}

.profile-switcher__tab:hover {
  background: rgba(19, 161, 199, 0.1);
  color: #20324f;
}

.profile-switcher__tab:focus-visible {
  outline: 2px solid #13a1c7;
  outline-offset: 2px;
}

.profile-switcher__tab--active {
  background: #20324f;
  box-shadow: 0 8px 20px rgba(32, 50, 79, 0.18);
  color: #fff;
  cursor: default;
  pointer-events: none;
}

.profile-switcher__tab--active:hover {
  background: #20324f;
  color: #fff;
}

.profile-switcher__avatar {
  border: 2px solid rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  flex-shrink: 0;
  height: 32px;
  object-fit: cover;
  width: 32px;
}

.profile-switcher__tab--active .profile-switcher__avatar {
  border-color: rgba(255, 255, 255, 0.35);
}

.profile-switcher__name--short {
  display: none;
}

.profile-switcher__name {
  white-space: nowrap;
}

@media (min-width: 768px) {
  .profile-switcher {
    width: auto;
  }

  .profile-switcher__tab {
    flex: 0 1 auto;
    font-size: 0.8rem;
    min-width: 260px;
    padding: 8px 18px;
  }

  .profile-switcher__tab:last-child {
    min-width: 220px;
  }
}

@media (max-width: 767px) {
  .profile-switcher {
    background: transparent;
    border: 0;
    border-radius: 0;
    flex-direction: column;
    gap: 8px;
    padding: 0;
  }

  .profile-switcher__tab {
    background: #f4f7fa;
    border: 1px solid rgba(32, 50, 79, 0.12);
    border-radius: 14px;
    box-shadow: 0 8px 18px rgba(32, 50, 79, 0.08);
    font-size: 0.94rem;
    gap: 10px;
    justify-content: flex-start;
    line-height: 1.1;
    min-height: 52px;
    padding: 9px 14px;
    text-align: left;
  }

  .profile-switcher__name {
    overflow-wrap: normal;
    word-break: normal;
  }

  .profile-switcher__avatar {
    height: 34px;
    width: 34px;
  }

  .profile-switcher__tab--active {
    background: #20324f;
    box-shadow: 0 10px 22px rgba(32, 50, 79, 0.18);
    color: #ffffff;
  }
}

@media (max-width: 380px) {
  .profile-switcher__avatar {
    height: 30px;
    width: 30px;
  }

  .profile-switcher__tab {
    font-size: 0.84rem;
    gap: 7px;
    padding: 8px 10px;
  }
}
</style>
